<template>
  <div class="contact__box">
    <div class="contact__box__floating">
      <div class="contact__box__floating__box">
        <div class="contact__box__floating__box__item">Start a projects</div>
        <div class="contact__box__floating__box__item__desc">Interested in working together? We should queue up a time to chat. I’ll buy the coffee.</div>
        <div class="contact__box__floating__box__item" @click="sendEmail">
          <div class="btn">
            Get in touch
          </div>
        </div>
      </div>
    </div>
    <div class="contact__box__under">
      <div>Boh</div>
      <img src="@/assets/am-low-resolution-logo-black-on-transparent-background.png"/>
      <div>Boh</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactView',
  data() {
    return {};
  },
  methods: {
    sendEmail() {
      window.location.href = "mailto:ale.mastropasqua.jb@gmail.com?subject=Let's do this&body=message%20goes%20here";
    }
  }
};
</script>

<style lang="scss" scoped>
.contact__box {
  height: 100%;
  // background: #88afa5;
  position: relative;
  &__floating {
    height: 30%;
    background: linear-gradient(#000 0 50%, #88afa5 0);
    position: relative;
    &__box {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      height: 90%;
      width: 80%;
      border: 1px solid black;
      border-radius: 10px;
      background: whitesmoke;
      display: flex;
      justify-content: space-between;
      align-items: center;
      &__item {
        font-size: 2vw;
        width: 100%;
        color: black;
        text-align: center;
        &__desc {
          font-size: 1vw;
          width: 100%;
        color: rgb(54, 77, 69);
        }
      }
    }
  }
  &__under {
    height: 70%;
    background: #88afa5;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: black;
    > img {
      height: 10vh;
    }
  }
}
.btn {
  border: 3px solid #88afa5;
  color: #56726b;
  width: fit-content;
  margin: auto;
  font-size: 1.5vw;
  padding: 2.5%;
  border-radius: 1in;
}
</style>
